<template>
	<div class="container">
		<div class="tishi">信息提示：</div>
		<div class="alert">绑定后可用于找回密码。</div>
		<el-form ref="form" label-width="100px" class="modify-form">
			<el-form-item label="邮箱">
				<el-input v-model="form.a" placeholder="请输入邮箱地址"></el-input>
			</el-form-item>
			<div style="text-align:center">
				<el-button type="primary">保存</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
export default {
	data() {
		return {
			form: {}
		};
	}
};
</script>


<style lang="scss" scoped>
.tishi {
	padding-left: 10px;
	font-size: 18px;
	font-weight: 600;
	margin-top: 20px;
	color: #000;
}
.alert {
	margin-top: 20px;
	padding: 10px 20px;
	background: #eee;
}
.modify-form {
	margin-top: 20px;
}
</style>

